// extracted by mini-css-extract-plugin
export var content = "_ad-1";
export var modal = "_ad-0";